export const PAST_PERFORMANCE = "PAST_PERFORMANCE";
export const PAST_PERFORMANCE_ADD_MSG = "PAST_PERFORMANCE_ADD_MSG";
export const PAST_PERFORMANCE_CLEAR_MSG = "PAST_PERFORMANCE_CLEAR_MSG";
export const PAST_PERFORMANCE_ERROR = "PAST_PERFORMANCE_ERROR";
export const PAST_PERFORMANCE_HIDE_ERROR = "PAST_PERFORMANCE_HIDE_ERROR";
export const PAST_PERFORMANCE_START_LOADER = "PAST_PERFORMANCE_START_LOADER";
export const PAST_PERFORMANCE_STOP_LOADER = "PAST_PERFORMANCE_STOP_LOADER";
